module.exports = __webpack_public_path__ + "img/icon6.84dbb17a.png";